/**
 * Returns true if the input is strictly equal to boolean true, number 1 or string '1'
 * @param {boolean|number|string} e - The input value to check
 * @returns {boolean}
 */
export const isTrue = e => true === e || 1 === e || '1' === e;
